import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Paths } from '@/common/const';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { Result } from '@/services/HttpService';
import { BackendStatusResponse } from '@/services/IHttpService';

export const MaintenanceChecker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { httpService } = useHttpContext();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const checkBackendStatus = async () => {
            try {
                const result: Result<BackendStatusResponse> = await httpService.getBackendStatus();
                const status = (result as BackendStatusResponse).status;
                const currentPath = location.pathname;
                console.log({ currentPath, status });

                if (status === 'MAINTENANCE' && currentPath !== Paths.maintenance) {
                    // Backend is under maintenance and user is not on maintenance page
                    navigate(Paths.maintenance, { replace: true });
                } else if (status === 'LIVE' && currentPath === Paths.maintenance) {
                    // Backend is live and user is on maintenance page
                    navigate(Paths.main, { replace: true });
                }
            } catch (error) {
                console.error('Failed to check backend status:', error);
            }
        };

        checkBackendStatus();
    }, [httpService, location.pathname, navigate]);

    return <>{children}</>;
};
